import {
  Panel as PanelComponent,
  PanelGroup as PanelGroupComponent,
  PanelResizeHandle as PanelResizeHandleComponent,
} from "react-resizable-panels";

import { chakra } from "@chakra-ui/react";

export const Panel = chakra(PanelComponent);
export const PanelGroup = chakra(PanelGroupComponent);
export const PanelResizeHandle = chakra(PanelResizeHandleComponent);
